"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactIntl = require("react-intl");

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _reactTransitionGroup = require("react-transition-group");

var _index = _interopRequireDefault(require("../input/index"));

var _groups = _interopRequireDefault(require("./groups"));

var _entries = _interopRequireDefault(require("./entries"));

var _style = _interopRequireDefault(require("./style.css"));

var _messages = _interopRequireDefault(require("../select/messages"));

var _messages2 = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var positionValues = {
  top: 'top',
  bottom: 'bottom'
};

var GroupSelect = /*#__PURE__*/function (_Component) {
  _inherits(GroupSelect, _Component);

  var _super = _createSuper(GroupSelect);

  function GroupSelect() {
    var _this;

    _classCallCheck(this, GroupSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "allGroupValue", 'allElementsGroup');

    _defineProperty(_assertThisInitialized(_this), "compareElementsByLabel", function (a, b) {
      var getVal = function getVal(x) {
        return x && x.label ? x.label.toLowerCase() : '';
      };

      var va = getVal(a);
      var vb = getVal(b);
      return va > vb ? 1 : va < vb ? -1 : 0;
    });

    _defineProperty(_assertThisInitialized(_this), "getAllGroup", function () {
      var options = _this.props.options;
      var optionsAvailable = !!(options && options.length);

      if (!optionsAvailable) {
        return null;
      } //Use Map to avoid duplication of objects with the same value


      var allChildrenMap = new Map();
      options.forEach(function (group) {
        var children = group.children;

        if (children && children.length > 0) {
          children.forEach(function (child) {
            allChildrenMap.set(child.value, child);
          });
        }
      });

      var allChildren = _toConsumableArray(allChildrenMap.values());

      if (allChildren.length > 0) {
        allChildren.sort(_this.compareElementsByLabel);
        var allGroup = {
          label: _this.getAllGroupLabel(),
          value: _this.allGroupValue,
          children: allChildren
        };
        return allGroup;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getAllGroupLabel", function () {
      return _this.props.allGroupLabel || _this.props.intl.formatMessage(_messages2["default"].allGroupLabel);
    });

    _defineProperty(_assertThisInitialized(_this), "state", {
      position: positionValues.bottom,
      visible: false,
      group: _this.props.initialGroup
    });

    _defineProperty(_assertThisInitialized(_this), "determineDropdownPosition", function () {
      if (_this.inputRef && _this.containerRef) {
        var inputRect = _this.inputRef.getBoundingClientRect();

        var containerRect = _this.containerRef.getBoundingClientRect();

        var height = containerRect.bottom - containerRect.top + 1;
        var marginToInput = 5;
        var marginToWindow = 32;
        var margin = marginToInput + marginToWindow;
        var heightUnder = document.documentElement.clientHeight - inputRect.bottom - margin;
        var heightAbove = inputRect.top - margin;

        _this.setState({
          position: height <= heightUnder || height > heightAbove && heightUnder >= heightAbove ? positionValues.bottom : positionValues.top
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.setState({
        position: positionValues.bottom
      });

      _this.determineDropdownPosition();
    });

    _defineProperty(_assertThisInitialized(_this), "setContainerRef", function (ref) {
      return _this.containerRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "setInputRef", function (ref) {
      return _this.inputRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "setVisibility", function () {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (visible === _this.state.visible) {
        return;
      }

      if (visible && _this.props.input.onFocus) {
        _this.props.input.onFocus();
      }

      if (!visible && _this.props.input.onBlur) {
        // Pass current value on blur to avoid issues
        // in custom parse/format/normalize handlers
        // See: https://github.com/erikras/redux-form/issues/2768
        _this.props.input.onBlur(_this.props.input.value);
      }

      _this.setState({
        visible: visible,
        position: visible ? _this.state.position : positionValues.bottom
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleVisible", function () {
      _this.setVisibility(!_this.state.visible);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setVisibility(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleGroupChange", function (value) {
      _this.setState({
        group: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChildrenChange", function (option) {
      _this.handleMultiChange([option]);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMultiChange", function (options) {
      var _this$props = _this.props,
          input = _this$props.input,
          groupKey = _this$props.groupKey,
          childrenKey = _this$props.childrenKey,
          propOptions = _this$props.options;
      var allOptions = [];
      propOptions.forEach(function (group) {
        group.children.forEach(function (child) {
          var _allOptions$push;

          allOptions.push((_allOptions$push = {}, _defineProperty(_allOptions$push, groupKey, group.value), _defineProperty(_allOptions$push, "label", child.label), _defineProperty(_allOptions$push, "value", child.value), _allOptions$push));
        });
      });

      var changedOptions = _toConsumableArray(options.filter(function (x) {
        return x.group !== _this.allGroupValue;
      }));

      var optionsFromAllGroup = options.filter(function (x) {
        return x.group === _this.allGroupValue;
      });
      optionsFromAllGroup.forEach(function (option) {
        changedOptions = changedOptions.concat(allOptions.filter(function (y) {
          return option.value === y.value;
        }).map(function (z) {
          return _objectSpread(_objectSpread({}, z), {}, {
            checked: option.checked
          });
        }));
      });
      var value = input.value || []; // The set with removed items
      // Items are compared using two keys, so the map is nested two levels deep

      var removedSet = changedOptions.reduce(function (acc, item) {
        return item.checked ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, item.group, _objectSpread(_objectSpread({}, acc[item.group]), {}, _defineProperty({}, item.value, true)))) : acc;
      }, {});

      var notRemoved = function notRemoved(item) {
        return !(removedSet[item[groupKey]] && removedSet[item[groupKey]][item[childrenKey]]);
      };

      var added = changedOptions.filter(function (item) {
        return item.checked === false;
      }).map(function (item) {
        var _ref;

        return _ref = {}, _defineProperty(_ref, groupKey, item.group), _defineProperty(_ref, childrenKey, item.value), _ref;
      });
      var updatedValue = value.filter(notRemoved) // Removed unchecked items
      .concat(added); // Add newly checked items

      input.onChange(updatedValue);
    });

    _defineProperty(_assertThisInitialized(_this), "humanizeOutputValue", function (options, input) {
      var _this$props2 = _this.props,
          maxLength = _this$props2.maxLength,
          groupKey = _this$props2.groupKey,
          childrenKey = _this$props2.childrenKey;
      var value = input.value || [];
      var humanizedValue = options.reduce(function (previousOption, currentOption) {
        var selectValues = currentOption.children.filter(function (children) {
          return value.find(function (a) {
            return a[groupKey] === currentOption.value && a[childrenKey] === children.value;
          });
        }).map(function (a) {
          return {
            label: a.label,
            type: 'children'
          };
        });

        if (selectValues.length && selectValues.length === currentOption.children.length) {
          return [].concat(_toConsumableArray(previousOption), [{
            label: currentOption.label,
            type: 'group'
          }]);
        }

        return [].concat(_toConsumableArray(previousOption), _toConsumableArray(selectValues));
      }, []).sort(function (a, b) {
        return a.type === b.type ? 0 : a.type < b.type ? 1 : -1;
      }).map(function (a) {
        return a.label;
      });

      if (humanizedValue.length > maxLength) {
        return [].concat(_toConsumableArray(humanizedValue.splice(0, maxLength)), ["+".concat(humanizedValue.length)]);
      }

      return humanizedValue;
    });

    return _this;
  }

  _createClass(GroupSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.determineDropdownPosition();
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.visible && this.state.visible) {
        this.determineDropdownPosition();
      }
    }
  }, {
    key: "getActiveGroup",
    value: function getActiveGroup() {
      if (this.state.group !== null) {
        return this.state.group;
      }

      var _this$props3 = this.props,
          options = _this$props3.options,
          showAllGroup = _this$props3.showAllGroup;

      if (showAllGroup) {
        return this.allGroupValue;
      } else if (options && options[0] && options[0].value) {
        return options[0].value;
      }

      return null;
    }
  }, {
    key: "countSelectedGroupItems",
    value: function countSelectedGroupItems(selectedValues, groupKey) {
      return selectedValues.reduce(function (acc, value) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, value[groupKey], (acc[value[groupKey]] || 0) + 1));
      }, {});
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          options = _this$props4.options,
          showAllGroup = _this$props4.showAllGroup,
          allGroupLabelForInput = _this$props4.allGroupLabelForInput,
          intl = _this$props4.intl,
          input = _this$props4.input,
          meta = _this$props4.meta,
          label = _this$props4.label,
          groupKey = _this$props4.groupKey,
          childrenKey = _this$props4.childrenKey,
          name = _this$props4.name,
          size = _this$props4.size,
          placeholder = _this$props4.placeholder,
          containerClassName = _this$props4.containerClassName,
          disabled = _this$props4.disabled;
      var value = input.value || [];
      var activeGroup = this.getActiveGroup();
      var groups = options.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          active: option.value === activeGroup
        });
      });
      var allGroupSelectedCount;
      var isAllElementsInAllGroupSelected = false;

      if (showAllGroup && groups.length > 0) {
        var allGroup = this.getAllGroup();
        allGroup.active = allGroup.value === activeGroup;

        if (allGroup) {
          groups.splice(0, 0, allGroup);
        }

        if (allGroup.children) {
          allGroupSelectedCount = allGroup.children.reduce(function (count, x) {
            return value.some(function (v) {
              return v[childrenKey] === x.value;
            }) ? ++count : count;
          }, 0);
          isAllElementsInAllGroupSelected = allGroupSelectedCount === allGroup.children.length;
        }
      }

      var groupObject = groups.find(function (a) {
        return a.value === activeGroup;
      });

      var isChecked = function isChecked(selectedItem) {
        if (activeGroup === _this2.allGroupValue) {
          return value.some(function (a) {
            return a[childrenKey] === selectedItem.value;
          });
        } else {
          return value.some(function (a) {
            return a[groupKey] === activeGroup && a[childrenKey] === selectedItem.value;
          });
        }
      };

      var entries = groupObject && (groupObject.children || []).map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          checked: isChecked(option),
          group: activeGroup
        });
      });
      var selectedCountMap = this.countSelectedGroupItems(value, groupKey);

      if (allGroupSelectedCount != null) {
        selectedCountMap[this.allGroupValue] = allGroupSelectedCount;
      }

      var optionsAvailable = !!(options && options.length);
      var inputElementValue = isAllElementsInAllGroupSelected ? allGroupLabelForInput || this.getAllGroupLabel() : this.humanizeOutputValue(options, input).join(', ');
      return /*#__PURE__*/_jsx("div", {
        className: cx('xsui-group-select')
      }, void 0, /*#__PURE__*/_jsx(_index["default"], {
        input: {
          name: input.name || name,
          value: inputElementValue,
          onChange: function onChange() {
            return void 0;
          }
        },
        containerRef: this.setInputRef,
        meta: meta,
        size: size,
        offset: "right",
        placeholder: placeholder || intl.formatMessage(_messages["default"].placeholder),
        focused: this.state.visible,
        disabled: disabled || !optionsAvailable,
        icon: "dropdown-select",
        readOnly: true,
        onClick: this.toggleVisible
      }), /*#__PURE__*/_jsx(_reactTransitionGroup.TransitionGroup, {}, void 0, optionsAvailable && this.state.visible ? /*#__PURE__*/_jsx(_reactTransitionGroup.CSSTransition, {
        classNames: "slide-transition",
        timeout: 150
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: cx('xsui-group-select__transition-container', "xsui-group-select__transition-container--position-".concat(this.state.position), containerClassName)
      }, void 0, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.setContainerRef,
        className: cx('xsui-group-select__container', "xsui-group-select__container--position-".concat(this.state.position), containerClassName)
      }, /*#__PURE__*/_jsx(_groups["default"], {
        options: groups,
        handleChange: this.handleGroupChange,
        selectedCountMap: selectedCountMap
      }), /*#__PURE__*/_jsx(_entries["default"], {
        activeGroup: activeGroup,
        options: entries,
        label: label,
        handleChange: this.handleChildrenChange,
        handleMultiChange: this.handleMultiChange
      })))) : null));
    }
  }]);

  return GroupSelect;
}(_react.Component);

_defineProperty(GroupSelect, "defaultProps", {
  meta: {
    touched: false,
    error: null
  },
  maxLength: 4,
  showAllGroup: false,
  groupKey: 'group',
  childrenKey: 'children',
  containerClassName: '',
  initialGroup: null,
  disabled: false
});

var _default = (0, _reactIntl.injectIntl)((0, _reactOnclickoutside["default"])(GroupSelect));

exports["default"] = _default;